<script lang="ts">
  import type { ImportedCity, Plan } from '$lib/types'
  import { resolveBuilding } from '$lib/catalogue'

  interface Props {
    plan: Plan | null
    importedCity: ImportedCity | null
    hoveredId: number | null
    /** Cursor position relative to the canvas host. Null hides the tooltip. */
    cursor: { x: number; y: number } | null
  }

  const { plan, importedCity, hoveredId, cursor }: Props = $props()

  const info = $derived.by(() => {
    if (hoveredId === null || !plan || !cursor) return null
    const building = plan.buildings.find((b) => b.id === hoveredId)
    if (!building) return null
    const resolved = resolveBuilding(building.cityentityId, importedCity ?? undefined)
    return {
      name: resolved?.name ?? 'Unknown entity',
      width: resolved?.width ?? 1,
      height: resolved?.height ?? 1,
      type: resolved?.type ?? 'unknown',
    }
  })
</script>

{#if info && cursor}
  <!-- Cursor-anchored popover. pointer-events: none so it never intercepts
       canvas clicks; offset 14px right + 18px down so the cursor doesn't
       cover the first character. Reads chrome variables (light text on dark
       chrome surface) so it pops over the canvas in every theme. -->
  <div
    class="pointer-events-none absolute z-30 rounded-md border border-border-rule bg-surface-5 px-2.5 py-1.5 text-xs text-chrome-text shadow-lg"
    style:left="{cursor.x + 14}px"
    style:top="{cursor.y + 18}px"
  >
    <p class="font-semibold leading-tight">{info.name}</p>
    <p class="mt-0.5 text-[11px] text-chrome-text-2">
      {info.width}×{info.height} · {info.type}
    </p>
  </div>
{/if}
